<template>

  <main ref="page" id="page" class="grid-x align-center portfolio-page">

    <!--if the currentClient is not set, show a feature block and logo array-->
    <template v-if="!currentClient">
      <!--
      <article class="medium-7 featured-project">
        <section class="featured-project-image">
          <a href="/portfolio/range">
            <img src="../images/sample-range-01.png">
          </a>
        </section>
        <section>
          <h1 class="verlag-bold">Range Design & Architecture Website</h1>
          <p class="featured-text">
            <a href="https://rangedesign.com" target="_blank">Visit</a> the site or
            <a href="/portfolio/range">read</a> more about the project.</p>
        </section>
      </article>
      -->
    </template>


    <!--
      <template v-for="item in portfolioProp">
        <template v-if="currentClient === item.client">
          <p>{{ item.client }}</p>
        </template>
      </template>


    -->


    <app-client-logos v-if="!currentClient">
      <!--content of component goes in slot in the ClientLogos.vue-->
      <!-- an alternative for :to and longer? or less dynamic is probably more accurate
        :to="{path: '/portfolio/' + project.client}">
        vs. using a named route (set in routes.js)
        with `name` and `params` as a 2nd argument as object with the params -->
      <router-link v-for="project in clientProp"
                   :key="project.client"
                   class="cell"
                   :to="{ name: 'portfolio-detail', params: { client: project.client } }">
        <img :src="'img/'+ project.logo"
        >

      </router-link>
    </app-client-logos>


    <router-view name="portfolioDetail">

      <!--<div v-if="!clientProp[currentClient]">error</div>-->

      <template slot="clientInfo" v-if="clientProp[currentClient]">


        <!--<transition-group name="doz" appear>-->


        <!-- SAMPLES from workData.js -->
        <section ref="projectcontent" key="project_content" id="project_content" class="project-content">


          <!-- INLINE FRAME: AD SAMPLES -->
          <template v-if="clientProp[currentClient].adSource">

            <div id="ad_wrapper" class="ad-wrapper">
              <iframe id="inline_ad_frame"
                      class="inline-ad-frame "
                      key="iframe_ad"
                      :width="selectedAd.width"
                      :height="selectedAd.height"
                      :src="selectedAd.src">
              </iframe>
            </div>
          </template>

          <!-- FIGURES: WORK IMAGES =-->
          <template v-for="(item, index) in clientProp[currentClient].imageSet">
            <figure class="portfolio-image"
                    v-show="index === currentWorkSampleId"
                    :key="'fig_' + index"
                    :id="'fig_' + index">
              <img :src="'/img/' + item.src" alt="">
              <figcaption>{{ item.caption }}</figcaption>
            </figure>
          </template>


          <!-- NAV: IMAGE DISPLAY -->
          <nav v-if="!clientProp[currentClient].adSource">
            <template v-for="(image, index) in clientProp[currentClient].imageSet">
              <button type="button"
                      :key="'image_button_' + index"
                      :class="{active: index === currentWorkSampleId}"
                      class="work-button"
                      @click="showWorkSample(index)">{{ index+1 }}
              </button>
            </template>
          </nav>

          <!-- NAV: INLINE FRAME AD SAMPLES -->
          <nav v-if="clientProp[currentClient].adSource" class="ad-frame-nav">
            <span>View Banners</span>
            <template v-for="(image, index) in clientProp[currentClient].adSource">
              <button type="button"
                      :key="'ad_button_' + index"
                      :class="{active: index === selectedAd.id}"
                      class="work-button"
                      @click.stop="showAnimatedFrame(index)">{{ index+1 }}
              </button>
            </template>
            <span id="ad_frame_toggle" @click="hideAnimatedFrame">Close</span>
          </nav>

        </section>
        <!--</transition-group>-->

        <!-- TEXT CONTENT BELOW IMAGES -->
        <transition name="slide-fade" appear>
          <section ref="textcontent" id="text_content">

            <h1>
              <a v-if="clientProp[currentClient].link" class="verlag-bold work-external-link"
                 :href="clientProp[currentClient].link" target="_blank">{{clientProp[currentClient].title}}</a>
              <span v-else>{{clientProp[currentClient].title}}</span>
            </h1>

            <section class="project-text" v-html="clientProp[currentClient].description"></section>
          </section>
        </transition>

      </template>

    </router-view>

  </main>

</template>


<script>

  // import {TweenMax} from 'gsap';
  import ClientLogos from './ClientLogos.vue';

  // page1 = document.getElementById("page");
  // page2 = this.$refs.page;
  // TweenMax.set(page, { alpha:0.5 });

  export default {

    props: ['clientProp', 'portfolioProp'],

    data() {
      return {
        show: false,

        currentClient: this.$route.params.client,
        currentWorkSampleId: 0,

        selectedAd: {
          id: undefined,
          width: "",
          height: "",
          src: ""
        }

      }
    },

    components: {
      appClientLogos: ClientLogos
    },

    computed: {
      // activeWorkSample() {
      //   return this.currentWorkSampleId
      // }
    },

    methods: {
      addListener() {
        let page = document.getElementById("page");
        // page.addEventListener("click", function() {console.log("EH!?")}, false );
        let vm = this;
        page.addEventListener("click", vm.hideAnimatedFrame);
      },
      navigateToHome() {
        this.$router.push('/');
      },
      checkClientPath() {
        console.log("~~~~~~~~ checking client path: ", this.currentClient);
      },
      showWorkSample(index) {
        // console.log(event);
        console.log("index:", index);
        this.currentWorkSampleId = index;
        let slide = document.getElementById("fig_" + index);
        console.log("slide:", slide);
        // var img = document.getElementById("page");
        // var fig = document.getElementById("fig_" + index);
        // console.log(fig);
        // TweenMax.to(slide, 0.5, {autoAlpha:1});
      },


      showAnimatedFrame(index) {
        // this.addListeners();
        let page = document.getElementById("page");
        // page.addEventListener("click", function() {console.log("EH!?")}, false );
        let vm = this;
        page.addEventListener("click", vm.hideAnimatedFrame);


        let adWrapper = document.getElementById("ad_wrapper");
        // let iframe = document.getElementById("inline_ad_frame");
        let fig0 = document.getElementById("fig_0");
        let adFrameToggle = document.getElementById("ad_frame_toggle");

        this.selectedAd.id = index;
        this.selectedAd.width = this.clientProp[this.currentClient].adSource[index].width;
        this.selectedAd.height = this.clientProp[this.currentClient].adSource[index].height;
        this.selectedAd.src = this.clientProp[this.currentClient].adSource[index].src;

        adWrapper.style.visibility = "visible";
        adFrameToggle.style.visibility = "visible";
        fig0.style.opacity = "0.10";

        if (this.selectedAd.height > 300) {
          fig0.style.height = (this.selectedAd.height + 50) + "px";
          adWrapper.style.height = (this.selectedAd.height + 50) + "px";
        } else {
          fig0.style.height = "auto";
          adWrapper.style.height = (fig0.clientHeight + 50) + "px";
          //   adWrapper.style.height = fig0.clientHeight.toString();
        }

        if (fig0.clientHeight < adWrapper.clientHeight) {
          adWrapper.style.height = fig0.clientHeight + "px";
        }

        console.log("----------------->> ", fig0.clientHeight);
        console.log("~~~~~~~~~~~~~~~~~~~");
        console.log("----------------->> ", adWrapper.clientHeight);


      },

      hideAnimatedFrame() {
        console.log("HIDE AD FRAME", event.target);
        let fig0 = document.getElementById("fig_0");
        let adWrapper = document.getElementById("ad_wrapper");
        let adFrameToggle = document.getElementById("ad_frame_toggle");
        fig0.style.opacity = "1";
        adFrameToggle.style.visibility = "hidden";

        this.selectedAd.id = undefined;
        this.selectedAd.width = "";
        this.selectedAd.height = "";
        this.selectedAd.src = "";

        fig0.style.height = "auto";
        adWrapper.style.height = "";

        let page = document.getElementById("page");
        let vm = this;
        page.removeEventListener("click", vm.hideAnimatedFrame);

        return true;
      }

      // handleMobileNav() {
      //   if (this.showMobileNav) {
      //     TweenMax.to(this.$refs.mobileNav, 0.15, {autoAlpha: 1});
      //   } else {
      //     TweenMax.to(this.$refs.mobileNav, 0.15, {autoAlpha: 0});
      //   }
      // },
    },

    beforeCreate() {
      console.log("BEFORE CREATE");
      console.log("~~~~~~~~ BEFORE client path: ", this.currentClient);
    },

    created() {
      console.log("CREATED");
      console.log("~~~~~~~~ CREATED currentClient: ", this.currentClient);
      console.log("~~~~~~~~ CREATED portfolioProp: ", this.portfolioProp);
      console.log("~~~~~~~~ CREATED clientProp: ", this.clientProp);
      // console.log("~~~~~~~~ CREATED clientProp: ", this.clientProp.shenshen.description);
      // console.log("~~~~~~~~ CREATED clientProp: ", this.clientProp[currentClient].description);
      // console.log("~~~~~~~~ CREATED clientList: ", this.clientList);
      // this.navigateToHome();


      // LOOKING AT HAVING A CLIENT LIST TO CHECK CURRENT CLIENT AGAINST
      // add :clientList="$options.clientList" to app.vue to use as a prop
      /* includes()
      * var array1 = [1, 2, 3];
      * console.log(array1.includes(2));
      * // expected output: true
      * */
      // console.log("$route", this.$route);
      // console.log(this.$route.name);
      // console.log('~>>> ' + this.clientList.includes(this.currentClient));
      // let clientOnList = this.clientList.includes(this.currentClient);
      // let output = clientOnList ? "POW" : "SORRY";
      // console.log(output);
      // console.log(clientOnList);
      // ! clientOnList ? this.navigateToHome() : true;
      // if (this.$route.name !== 'portfolio' && !clientOnList) {
      //   // this.navigateToHome();
      //   this.$router.push('/portfolio');
      // }

      // for-in is for Objects
      // for (var property1 in object1) {
      //   string1 = string1 + object1[property1];
      // }
      // for (const prop in this.portfolioProp) {
      //   console.log(`obj.${prop} = ${this.portfolioProp[prop]}`);
      // }


      /*
      * The find() method returns the value of the first element in the array
      * that satisfies the provided testing function. Otherwise undefined is returned.
      * */

      // you can use forEach on Arrays, not on Objects
      // seems like Vue will handle them the same: https://vuejs.org/v2/guide/list.html
      // this.portfolioProp.forEach(item => {
      //   console.log(item.client);
      // });


      // for (var item in this.portfolioProp) {
      //   console.log(item);
      // }

    },

    beforeMount() {
      console.log("BEFORE MOUNT");
    },

    // mounted means on the DOM
    mounted() {
      console.log("MOUNTED");
      // console.log(this.$refs.page);
      // console.log(document.getElementById("page"));
      // let page = document.getElementById("page");
      // page.addEventListener("click", function() {console.log("EH!?")}, false );
    },

    beforeUpdate() {
      console.log("BEFORE UPDATE");
      if (!this.currentClient) {
        console.log("UPDATING>>>>>>>>>>>>>>>>>>>>>>>");
        this.selectedAd.width = "";
        this.selectedAd.height = "";
        this.selectedAd.src = "";
        this.selectedAd.id = undefined;
      }
    },

    updated() {
      console.log("PORTFOLIO VUE UPDATED");
      // TweenMax.to(this.$refs.projectcontent, 0.6, {alpha: 1});
      // TweenMax.to(this.$refs.textcontent, 0.6, {alpha: 1});
    },

    destroyed() {
      console.log("DESTROYED");
    },

    watch: {
      '$route'(to, from) {
        console.log('~~~~> ', to);
        this.currentWorkSampleId = 0;
        this.currentClient = to.params.client;
      }
    }
  }
</script>


<style lang="scss">
  @import '~foundation-sites/scss/foundation.scss';
  @import '../css/settings';
  @import '../css/colors';

  .show-on-mobile {
    display: block;
  }

  @include breakpoint(medium) {
    .show-on-mobile {
      display: none;
    }
  }

  button {
    padding: 20px;
    color: white;
  }

  h1, h2, h3, h4 {
    color: $deepBlue;
    /*font-size: 1.5625rem;*/
    font-family: "Verlag A", "Verlag B", sans-serif;
    font-style: normal;
    font-weight: 700;

    .work-external-link {
      color: $deepHaze;

      &:hover {
        color: $deepBlue;
        text-decoration: underline;
      }
      &::after {
        content: "\f010";
        padding-left: .4rem;
        font-family: 'SocialBrands-Regular', sans-serif;
        font-size: 1rem;
        font-weight: normal;
        speak: none;
      }
    }
  }

  h1 {
    /*margin-bottom: 1rem;*/
    margin-bottom: 0.5rem;
    font-size: 1.25rem;
    @include breakpoint(middle) {
      font-size: 1.5rem;
    }
  }

  h2, h3 {
    font-size: .875rem;
  }

  h3, h4 {
    color: $deepYellow;
  }

  .work-external-link-text {
    color: $deepHaze;
    font-family: "Verlag A", "Verlag B", sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 1.125rem;

    span {
      text-decoration: underline;
    }

    &:hover {
      color: $deepBlue;
      text-decoration: underline;
    }

    &::after {
      content: "\f010";
      padding-left: .4rem;
      font-family: 'SocialBrands-Regular', sans-serif;
      font-size: 1rem;
      font-weight: normal;
      speak: none;
    }
  }

  a:focus {
    text-decoration: underline;
  }

  .portfolio-page {

    padding-bottom: 3rem;
    .text-content {
      padding: 0 .5rem;
    }
    p, ul,
    p .work-external-link-text {
      font-family: "Chronicle SSm A", "Chronicle SSm B", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: .9375rem;
      @include breakpoint(medium) {
        font-size: 1rem;
      }
      @include breakpoint(large) {
        padding-right: 2rem;
      }
    }
    .project-text ul {
      margin: 0 0 1rem 0;
    }
    .project-text li {
      list-style-type: none;
      margin: 0;
    }

    p .work-external-link-text {
      padding: 0 2px;
      margin: 0;
      color: $deepHaze;
      &:hover {
        color: $deepBlue;
        text-decoration: underline;
      }

    }
  }

  .work-button {
    position: relative;
    z-index: 100;
    display: inline-block;
    padding: 1rem;
    line-height: 1.5;
    margin-right: .5rem;
    text-decoration: none;
    background: transparent;
    color: $deepHaze;
    font-family: sans-serif;
    font-size: 1rem;
    cursor: pointer;
    text-align: center;
    transition: background 250ms ease-in-out,
    transform 150ms ease;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .work-button.active {
    background: $deepPewter;
  }

  button:hover,
  button:focus {
    background: $deepPewter;
  }

  button:focus {
    outline: 1px solid #fff;
    outline-offset: 0;
  }

  .project-content {
    position: relative;
    margin-bottom: 20px;
    width: 100%;

    .placeholder {
      img {
        opacity: 0;
        visibility: hidden;
        max-width: 100%;
        max-height: 100%;
        margin: auto;
      }
    }

    figure.portfolio-image {
      /*position: absolute;*/
      /*visibility: hidden;*/

      figcaption {
        padding: .5rem 0;
        text-align: right;
        font-size: 1rem;
        font-family: "Verlag A", "Verlag B", sans-serif;
        font-style: italic;
        font-weight: 700;
      }
    }

    .ad-wrapper {
      z-index: 2;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      width: 100%;
      height: 100%;

      .inline-ad-frame {
        border: none;
      }
    }
    .ad-frame-nav {
      position: relative;
      z-index: 3;
      span {
        text-align: right;
        font-size: 1rem;
        padding-right: .5rem;
        font-family: "Verlag A", "Verlag B", sans-serif;
      }
      #ad_frame_toggle {
        visibility: hidden;
        cursor: pointer;
      }
    }
  }

  .featured-project {
    margin: 10px 0 40px 0;
    h1 {
      padding: 0;
      margin: -20px 0 0 30px;
      font-size: 1rem;
      color: white;
    }
    .featured-text {
      padding: 0;
      margin: 0 0 0 30px;
      color: $deepBlue;
      text-align: left;
      font-size: .9375rem;
      font-family: "Verlag A", "Verlag B", sans-serif;
      font-weight: 700;
      a {
        color: $deepBlue;
        border-bottom: 1px solid $deepBlue;
      }
    }
    @include breakpoint(middle) {
      //margin-left: -60px;
      h1 {
        padding: 0;
        margin: -40px 0 0 80px;
        font-size: 1.25rem;
      }
      .featured-text {
        padding: 0;
        margin: 0 0 0 80px;
      }
    }
    @include breakpoint(large) {
      //margin-left: -80px;
    }
  }

  .doz-enter {
    opacity: 0;
  }

  .doz-enter-active {
    transition: opacity .5s;
  }

  .doz-leave {
    /*opacity: 1;*/
  }

  .doz-leave-active {
    transition: opacity 1s;
    opacity: 0;
    position: absolute;
  }

  /*.doz-move {*/
  /*transition: transform 1s;*/
  /*}*/

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all .5s ease;
  }

  .slide-fade-leave-active {
    transition: all .5s;
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    /*transform: translateX(10px);*/
    opacity: 0;
  }

  // initial state for 1 frame
  .fade-enter {
    opacity: 0;
  }

  // animating state until it's done
  // don't set opacity, the initial state will be overridden
  .fade-enter-active {
    transition: all 1s;
  }

  // initial state by default 1
  .fade-leave {
    /*opacity: 1;*/
  }

  // animating state until it's done
  .fade-leave-active {
    transition: all 1ms;
    opacity: 0;
  }


</style>



// WEBPACK FOOTER //
// src/components/Portfolio.vue